import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import * as paths from "../../../constants/paths";

const ProfileJob = () => {
  return (
    <section className="job_outer new_profile_job">
      <div className="banner_blk"></div>
      <div className="contain job_inner">
        <div className="flex btn_flex">
          <div className="colL">
            <div className="sm_icon">
              <img src={paths.SITE_BASE_URL + "/images/new/job1.svg"} alt="" />
            </div>
            <div className="cntnt">
              <h5>
                AECOM Graduate Electrical Engineers ( Building Services) – 22/23{" "}
              </h5>
              <p>AECOM UK Inc.</p>
              <ul className="specific_info">
                <li>
                  <img
                    src={paths.SITE_BASE_URL + "/images/new/location.svg"}
                    alt=""
                  />{" "}
                  <span>
                    <div>London</div>
                  </span>
                </li>
                <li>
                  <img
                    src={paths.SITE_BASE_URL + "/images/new/teacher.svg"}
                    alt=""
                  />{" "}
                  <span>
                    <div>2:1</div>
                  </span>
                </li>
                <li>
                  <img
                    class="sm_icon_pound"
                    src={paths.SITE_BASE_URL + "/images/pound1.png"}
                    alt=""
                  />{" "}
                  <span>8000 - 17000 / Yearly</span>
                </li>
                <li>
                  <img
                    src={paths.SITE_BASE_URL + "/images/new/eye.svg"}
                    alt=""
                  />{" "}
                  <span>
                    <div>1300 Views</div>
                  </span>
                </li>
              </ul>
            </div>
            <div className="detail_jobs">
              <h5>Job Summary</h5>
              <p>
                AECOM is one of the world’s largest professional engineering
                consultancies, bringing a comprehensive portfolio of building
                services and engineering skills to projects encompassing all
                types of building and use from World Class Sporting Venues
                through to Commercial Properties, Healthcare & Research, Hotels,
                Industrial & Manufacturing, and Infrastructure both in the UK
                and increasingly overseas.
              </p>
              <p>
                Building services Electrical Engineers work closely with the
                design team to ensure the projects we create together
                sustainably perform to the brief and budget. Increasingly we
                work with our other internal business lines such as
                Architecture, Environment, Transportation, and our own Project
                Managers to provide a one stop solution to our clients. If you
                can bring passion and flair to our work, have a real interest in
                improving the built environment and want to now apply your
                engineering skills to the real world then we want to hear from
                you.
              </p>
              <p>
                We deliver expert thinking to drive efficient solutions for all
                aspects of building services Electrical Engineering including
                high and low voltage power supplies and distribution systems,
                incoming utilities, standby generation, UPS and resilient power
                solutions, renewable systems, power, lighting, fire alarms and
                security.
              </p>
              <p>
                As part of an international company you will have the
                opportunity to make connections regionally, nationally and
                internationally and the range of projects and opportunities is
                broad.
              </p>
              <p>
                Examples of projects the Building Services team are involved in
                include:
              </p>
              <ul>
                <li>
                  <strong>Forbury Place, Reading</strong> – AECOM were involved
                  with the development of two new-build office developments
                  totaling circa 400,000 sq ft. Building 2 has recently won the
                  prestigious BCO regional award and has been put forward for
                  the national finals. The offices were completed to category A
                  standard, achieving BREEAM Excellent, EPC A rated and Wired
                  Scope Platinum. Sustainable features include 700m2
                  photovoltaic panels (350m2 per building), air source heat
                  pumps and rainwater harvesting.
                </li>
                <li>
                  <strong>
                    Medical and Dental Facility, RAF Valley, Anglesey, Wales
                  </strong>
                  . The detailed design and specification for a new facility
                  based on the RAF site on Anglesey in North wales. The building
                  services needed to be designed in accordance with the usual
                  British Standards and Building regulations as well as
                  incorporating relevant parts of the Health technical Memoranda
                  (HTM’s) as required for compliance with Hospital standards.
                  Further, to this, the facility also had to comply with the JSP
                  Guidelines for MOD establishments in the UK. The project was
                  delivered in 3D to aid with clash detection and coordination
                  with the building and structural elements
                </li>
                <li>
                  <strong>Westferry, Isle of Dogs</strong> – 11 residential
                  blocks ranging up to 40 stories with large dock heating and
                  cooling scheme. We are providing MEP services, security, ICT,
                  lighting, sustainability, noise & vibration monitoring, fire,
                  acoustics & air quality
                </li>
                <li>
                  <strong>Old Bailey, London</strong> – Major plant replacement
                  for central plant, including lifts. Project going on over 11
                  years in phases whilst the site is occupied and fully
                  operational. AECOM are providing MEP services, lifts, and
                  structures.
                </li>
                <li>
                  <strong>Broadway Development, London</strong> – Mixed use high
                  end residential with offices and retail. AECOM are providing
                  MEP services, fire, acoustics, and sustainability.
                </li>
                <li>
                  <strong>Birchwood, Cambridgeshire</strong> – Office and lab
                  facility comprising of a campus of 4 separate buildings
                  including offices, conference room building, forum containing
                  canteen and presentation suite, and tech barn. Centralised
                  ground source heat pumps and PV. AECOM are providing MEP
                  services, fire, acoustics, sustainability, transport, air
                  quality, lighting, ICT & security
                </li>
                <li>
                  <strong>
                    TU Dublin West Quad Business School, Grangegorman
                  </strong>{" "}
                  - This project will feature a range of specialist and shared
                  learning spaces which will cater to the needs of a changing
                  third level education environment for the College of Business.
                  This project includes dynamic thermal modelling and natural
                  lighting BER A3 - NZEB, sustainable design, full mechanical
                  and electrical detailed design, to include a wide range of
                  specialist services. Part of what will be the Academic Hub of
                  the new TU Dublin Campus, the West Quad building will be
                  ideally located to the co-habited DCC and Campus libraries,
                  student housing and the west side of the Grangegorman campus
                  site.
                </li>
                <li>
                  Healthcare: Aecom are a leading award winning consultant for
                  the NHS in the UK and internationally. Our breadth and depth
                  stretches from £200m+ acute hospitals to health& wellbeing
                  primary care facilities and refurbishment works across the
                  healthcare estate. We are proud to have contributed to the
                  recent COVID Nightingale facilities and to be active
                  contributors to the strategies for the NHS to deliver their
                  Net Zero Carbon ambitions.
                </li>
              </ul>
              <p>
                When a graduate starts with us we pair them with an experienced
                engineer who will guide and mentor them through their initial
                period working on live projects.
              </p>
              <p>
                The following description lists a fairly typical approach to
                foundational training in your discipline; however, business
                needs, project task availability, and your training interests
                will also influence the scope and order of training. For your
                first year you will learn the following skills:
              </p>
              <ul>
                <li>
                  Design experience in the electrical engineering aspects of
                  project delivery
                </li>
                <li>
                  Application of electrical engineering to support sustainable
                  building design
                </li>
                <li>Delivery of projects using BIM</li>
                <li>AutoCad and REVIT</li>
                <li>
                  Calculations including electrical load, circuit design and
                  cable calculations, and lighting
                </li>
                <li>How to use the Technical Practice Network</li>
                <li>Learning to navigate through codes and guidelines</li>
                <li>Complete our Safety Training</li>
                <li>AECOM standards and symbols</li>
              </ul>
              <div className="br"></div>
              <p>
                <strong>What We Offer</strong>
              </p>
              <p>
                We will give you the flexibility you need to do your best work
                with hybrid work options. Whether you’re working from an AECOM
                office, remote location or at a client site, you will be working
                in a dynamic environment where your integrity, entrepreneurial
                spirit and pioneering mindset are championed. You will help us
                foster a culture of equity, diversity and inclusion – a safe and
                respectful workplace, where we invite everyone to bring their
                whole selves to work using their unique talents, backgrounds and
                expertise to create transformational outcomes for our clients.
                We will encourage you to grow and develop your career with us
                through our technical and professional development programs and
                diverse career opportunities. We believe in leadership at all
                levels. No matter where you sit in the organization you can make
                a lasting impact on the projects you work on, the teams and
                committees you join and our business. We offer competitive pay
                and benefits, well-being programs to support you and your
                family, and the development resources you need to advance your
                career. When you join us, you will connect and collaborate with
                a global network of experts – planners, designers, engineers,
                scientists, consultants, program and construction managers –
                leading the change toward a more sustainable and equitable
                future. Join us and let’s get started. As an Equal Opportunity
                Employer, we believe in each person’s potential, and we’ll help
                you reach yours.
              </p>
            </div>
            <div className="br"></div>
            <div class="btn_blk">
              <button class="site_btn ">
                Apply Now <i className="arrow"></i>
              </button>
            </div>
          </div>
          <div className="colR">
            <div class="btn_blk">
              <Link to="/apply" class="site_btn ">
                Apply Now <i className="arrow"></i>
              </Link>
              <button class="site_btn blank">
                Save this job{" "}
                <img
                  src={paths.SITE_BASE_URL + "/images/new/archive-add1.svg"}
                  alt=""
                />
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProfileJob;
